export default __webpack_public_path__ + "static/media/bla-strokes.d88b8399.png";